<template>  
  <v-container fluid grid-list-lg class="ma-0 pa-0">
    <v-layout row>
      <template v-for="(item,i) in items">
        <v-flex xs12 md4 :key="i">
          <v-card
            class="mx-auto"          
            outlined
          >
            <v-list-item three-line>
              <v-list-item-content>
                <div class="overline mb-4">Survey</div>
                <v-list-item-title class="headline mb-1">{{ ((1-1)*20)+(items.findIndex(x=>x==item)+1) }}. {{item.name}}</v-list-item-title>
                <v-list-item-subtitle>{{item.description}}</v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-avatar
                tile
                size="80"
                :color="item.color=='#fff'?'#000':item.color"
              ><v-icon large class="white--text">assignment</v-icon></v-list-item-avatar>
            </v-list-item>
            
            <v-card-text>
              <v-chip :to="{name:'survey/respon', query:{jilid_id:item.id}}" :color="item.color=='#fff'?'#000':item.color" dark><v-icon left>person</v-icon>{{item.counting.yours | currency}} yours</v-chip> &nbsp;
              <v-chip><v-icon left>person</v-icon> {{item.counting.all | currency}} all</v-chip>
              <template v-for="(widget, i) in widgets">
                <v-chip :key="i" class="ml-2" :color="widget.color" dark @click="openDialog(item, widget)"><v-icon left>extension</v-icon>{{widget.name}}</v-chip>              
              </template>              
            </v-card-text>            

            <v-card-actions>
              <v-btn large text color="green" :to="{name:'survey/respon/form', query:{jilid_id:item.id}}"><v-icon left>add</v-icon> New Respon</v-btn>
              <v-btn large text color="orange" :to="{name:'survey/respon', query:{jilid_id:item.id}}">list</v-btn>
              <v-spacer/>
              <v-btn small :color="item.offline?'green':'red'" icon :loading="item.loadingDownload" @click="downloadData(item)"><v-icon>{{item.offline?'check_circle':'signal_cellular_off'}}</v-icon></v-btn>
            </v-card-actions>

            <v-dialog v-model="item.dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
              <v-card>
                <v-app-bar dense dark :color="item.color=='#fff'?'#000':item.color" fixed>
                  <v-btn icon dark @click="item.dialog = false">
                    <v-icon>arrow_back</v-icon>
                  </v-btn>
                  <v-toolbar-title>{{item.name}}</v-toolbar-title>
                  <v-chip v-if="option.widget" class="ml-2" :color="option.widget.color" dark>{{option.widget.name}}</v-chip>
                  <v-spacer></v-spacer>
                  <v-menu bottom right offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn dark icon v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <template v-for="(widget, i) in widgets">
                        <v-list-item :key="i" @click="option.widget = widget">
                          <v-list-item-title>{{widget.name}}</v-list-item-title>                        
                        </v-list-item>
                      </template>                      
                    </v-list>
                  </v-menu>
                </v-app-bar>
                <div style="padding-top:48px">
                  <template v-if="option.widget">
                    <widget-sebaran v-if="option.widget.id === 1" :jilid="item" />                    
                  </template>
                </div>  
              </v-card>  
            </v-dialog>  

          </v-card>
        </v-flex>
      </template>
      <template v-if="loading">
        <v-flex xs12 md4 v-for="(i) in 12" :key="i">
          <v-skeleton-loader        
            style="width:100%"            
            type="card"
          ></v-skeleton-loader>
        </v-flex>
      </template>
    </v-layout>
    <v-layout>
      <v-flex xs12>
        <v-btn color="blue" v-if="page<totalPages" :loading="loading" dark @click="page = page + 1">Load More</v-btn>        
      </v-flex>
    </v-layout>
    
    <!--<v-card>
      <v-toolbar flat>      
        <v-text-field flat dense filled
          v-model="term"
          append-icon="search"
          label="Search"
          single-line
          hide-details        
          @input="search"
          style="max-width:200px"
        ></v-text-field>                 
        <v-spacer/>
        <v-btn fab color="green" dark small absolute right :to="{name:'master/quetionnaire/form'}"><v-icon>add</v-icon></v-btn>                      
      </v-toolbar>
    </v-card>--> 
  </v-container>  
</template>

<script>
import { debounce } from 'lodash'
import Survey  from '@/app/models/Survey'
import Node    from '@/app/models/master/Node'
import Tps     from '@/app/models/master/Tps'
import WidgetSebaran from './widget/sebaran'

export default {
  components:{WidgetSebaran},
  data () {
    return {
      term : null,     
      items: [],     
      pagination:{sortBy:[]},
      page : 1,      
      totalPages: 0,      
      loading: false,        
      widgets: [
        {id:1, name:'alokasi', color:'cyan'},        
      ],
      option:{
        widget:{},        
      }      
    }
  },
  computed:{
    status(){
      return this.$store.getters.DICTIONS.JilidStatus;      
    },    
  },
  watch:{
    page(newPage){
      this.readItems(newPage) 
    },
    pagination:{
      handler(){
        this.readItems(this.page) 
      }, deep:true      
    }
  },  
  created () {
    this.readItems()
  },
  methods: {
    openDialog(item, widget){
      item.dialog = true;
      this.option.widget = widget;
    },

    search: debounce(function (term) {
      this.term = term;
      this.readItems()
    }, 800),

    readItems (page = 0) {
      this.loading = true
      
      let  sortby = this.pagination.sortBy[0] ? this.pagination.sortDesc[0] ? 
        '-'+this.pagination.sortBy[0] : this.pagination.sortBy[0] : 'id';                          
      
      const params = {
        perPage: 20,
        page: page,
        q: this.term,
        status: 1,
        //sort:sortby,
        expand:'node,counting,quetionnaires'
      }
      Survey.jilids(params)
        .then(response => {
          if(Array.isArray(response.data)){
            response.data.forEach(item=>{
              item.dialog =false;
              item.loadingDownload = false;
              if(Survey.query().where((survey)=>{return survey.id==item.id}).first()){
                item.offline = true;             
              } else {
                item.offline = false;
              }             
            });            
          }
          this.items = [...this.items, ...response.data];
          this.totalPages = response.pagination.pageCount;               
          this.loading = false                    
        })
    },        

    downloadData(item){
      item.loadingDownload = true;      
      Node.insertOrUpdate({data:item.node}); 
      Node.index({jilid_id:item.id, parent_id : item.node.id, paging:false, expand:'lembar,lembarDone'}).then(res1=>{
        if(Array.isArray(res1.data)){              
          Node.insertOrUpdate({data: res1.data});
          res1.data.forEach(node1 => {
            if(node1.level != 4){
              Node.index({jilid_id:item.id, parent_id : node1.id, paging:false, expand:'lembar,lembarDone'}).then(res2=>{
                if(Array.isArray(res2.data)){             
                  Node.insertOrUpdate({data: res2.data});
                  res2.data.forEach(node2 => {
                    if(node2.level != 4){
                      Node.index({jilid_id:item.id, parent_id : node2.id, paging:false, expand:'lembar,lembarDone'}).then(res3=>{
                        if(Array.isArray(res3.data)){             
                          Node.insertOrUpdate({data: res3.data});
                          res3.data.forEach(node3 => {
                            if(node3.level == 4){                         
                              /*Tps.index({idkel : node3.id, paging:false}).then(res3tps=>{
                                if(Array.isArray(res3tps.data)){             
                                  Tps.insertOrUpdate({data: res3tps.data});
                                  item.loadingDownload = false;
                                  Survey.insertOrUpdate({data:item});  
                                  item.offline = true;                                
                                }
                              });*/
                              item.loadingDownload = false;
                              Survey.insertOrUpdate({data:item});  
                              item.offline = true;                                
                            }       
                          });
                        } 
                      });
                    } else {
                      Tps.index({idkel : node2.id, paging:false}).then(res2tps=>{
                        if(Array.isArray(res2tps.data)){             
                          Tps.insertOrUpdate({data: res2tps.data});
                          item.loadingDownload = false;
                          Survey.insertOrUpdate({data:item});
                          item.offline = true;
                        }
                      });
                    }
                  });
                } 
              });
            } else {
              Tps.index({idkel : node1.id, paging:false}).then(res1tps=>{
                if(Array.isArray(res1tps.data)){             
                  Tps.insertOrUpdate({data: res1tps.data});
                  item.loadingDownload = false;
                  Survey.insertOrUpdate({data:item});              
                  item.offline = true;
                }
              });              
            }  
          });
        }
      })
    },
  },  
}
</script>